module.exports = new __parcel__URL__("projectavatar.d4458fec.svg").toString();